import { IntlShape, MessageDescriptor, useIntl } from "react-intl";
import React, { useEffect } from "react";

export type TitleArgument = string | MessageDescriptor;

export const setTitle = (intl: IntlShape, ...args: TitleArgument[]) => {
    let titleStr = "Watamusic";
    for (const part of args) {
        titleStr = buildTitle(intl, part, titleStr);
    }
    document.title = titleStr;
};

const buildTitle = (intl: IntlShape, part: TitleArgument, title: string) => {
    if (part != null && isMessage(part)) {
        part = intl.formatMessage(part);
    }
    return part ? part + " | " + title : title;
};

function isMessage(msg: TitleArgument): msg is MessageDescriptor {
    return (msg as MessageDescriptor).id !== undefined;
}

const useTitleOnPage = (...args: TitleArgument[]) => {
    const intl = useIntl();
    useEffect(() => {
        setTitle(intl, ...args);
    }, [args]);
};

export const setTitleOnPage = (...args: TitleArgument[]) => (Component: React.ComponentType) => {
    return (props: any) => {
        useTitleOnPage(...args);
        return React.createElement(Component, props);
    };
};
